/**
 * # Custom Functions
 * Class group methods for actions triggered by the Rebuy Cart widget
 */
class CustomFunctions {
  /**
   * Updates the cart items counter with the provided count.
   * @param {number} count - The count of items to be displayed.
   */
  cartItemsCounterUpdate(count) {
    document
      .querySelectorAll(`[data-js-cart-count]`)
      .forEach((el) => (el.innerHTML = count));
  }
}

const customFunctions = new CustomFunctions();

document.addEventListener("rebuy:cart.change", function (event) {
  customFunctions.cartItemsCounterUpdate(event.detail.cart.itemCount());
});
